/*=========================================================================================
  File Name: moduleVehicleGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getCurrentVehicle: (state) => state.currentVehicle,
};
